import React, { useState } from 'react';
import { toast } from 'sonner';
import { Mail, Send } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { adminSendStatementsNow, adminTestStatement } from '../../lib/api';
import { inputCls } from './shared';

export default function StatementsTab() {
  const [stTest, setStTest] = useState({ investorEmail: '', to: '' });
  const [sendingTest, setSendingTest] = useState(false);
  const [sendingAll, setSendingAll] = useState(false);

  const sendTestStatement = async () => {
    setSendingTest(true);
    try {
      const r = await adminTestStatement({ investorEmail: stTest.investorEmail.trim(), to: stTest.to.trim() });
      if (r.ok) toast.success(`Test statement sent to ${r.to} (portfolio of ${r.investor})`);
      else toast.error(`Send failed: ${r.reason || 'unknown'}`);
    } catch (err) { toast.error(err?.response?.data?.detail || 'Failed'); }
    finally { setSendingTest(false); }
  };
  const sendAllStatements = async () => {
    if (!window.confirm('Email every onboarded investor with holdings their current statement now?')) return;
    setSendingAll(true);
    try { const r = await adminSendStatementsNow(); toast.success(`Statements sent: ${r.sent} (skipped ${r.skipped_no_holdings} without holdings)`); }
    catch (err) { toast.error(err?.response?.data?.detail || 'Failed'); }
    finally { setSendingAll(false); }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="space-y-3 rounded-2xl border border-white/10 bg-farmway-green-mid/40 p-5">
        <h3 className="flex items-center gap-2 font-display font-bold text-farmway-cream"><Mail className="h-4 w-4 text-farmway-gold" /> Email a test statement</h3>
        <p className="text-xs text-farmway-cream/50">Sends a sample statement PDF so you can review it before investors receive theirs on the 1st of each month.</p>
        <div className="space-y-1.5"><Label className="text-farmway-cream/80">Investor portfolio (optional)</Label><Input data-testid="statement-investor-input" value={stTest.investorEmail} onChange={(e) => setStTest({ ...stTest, investorEmail: e.target.value })} placeholder="Defaults to first investor with holdings" className={inputCls} /></div>
        <div className="space-y-1.5"><Label className="text-farmway-cream/80">Send to (optional)</Label><Input data-testid="statement-to-input" value={stTest.to} onChange={(e) => setStTest({ ...stTest, to: e.target.value })} placeholder="Defaults to your email" className={inputCls} /></div>
        <button data-testid="test-statement-btn" onClick={sendTestStatement} disabled={sendingTest} className="btn-gold w-full disabled:opacity-70"><Send className="h-4 w-4" /> {sendingTest ? 'Sending…' : 'Send test statement'}</button>
      </div>
      <div className="space-y-3 rounded-2xl border border-white/10 bg-farmway-green-mid/40 p-5">
        <h3 className="flex items-center gap-2 font-display font-bold text-farmway-cream"><Send className="h-4 w-4 text-farmway-gold" /> Monthly statement run</h3>
        <p className="text-xs text-farmway-cream/50">Statements are emailed automatically on the 1st of each month at 08:00 UTC. Use this to trigger the full run immediately, every onboarded investor with holdings receives their PDF.</p>
        <button data-testid="send-all-statements-btn" onClick={sendAllStatements} disabled={sendingAll} className="btn-outline w-full disabled:opacity-70"><Mail className="h-4 w-4" /> {sendingAll ? 'Sending…' : 'Send statements to all investors now'}</button>
      </div>
    </div>
  );
}
